import './Onboarding.scss'

import { Button, Col, Row } from 'react-bootstrap'
import cn from 'classnames'

import RembleLogomark from '../../../assets/images/Remble_Logomark-Green.png'
import { useState } from 'react'
import PracticesCarousel from '../PracticesCarousel'
import UserAssessment from 'components/assessment/UserAssessment'
import UserAssessmentComplete from 'components/assessment/UserAssessmentComplete'

// List of screens to display
const screenKeys = ['welcome', 'practices', 'privacy', 'personalize']

/**
 * Simple Onboarding component. Used to display the onboarding screens
 */
export default function Onboarding({ handleComplete }) {
  const [assessmentComplete, setAssessmentComplete] = useState(false)
  const [activeScreenIndex, setActiveScreenIndex] = useState(0)
  const [activeScreenKey, setActiveScreenKey] = useState(
    screenKeys[activeScreenIndex]
  )

  /**
   * Handles the assessment complete event, when the user finishes the assessment
   */
  const handleAssessmentComplete = () => {
    // Set the assessment complete flag
    setAssessmentComplete(true)
  }

  /**
   * Handles the continue button click
   */
  const handleContinue = () => {
    const nextScreenIndex = activeScreenIndex + 1
    const nextScreenKey = screenKeys[nextScreenIndex]

    // Update the active screen
    setActiveScreenIndex(nextScreenIndex)
    setActiveScreenKey(nextScreenKey)
  }

  return (
    <div className='onboarding-wrapper'>
      <Row>
        <Col
          key={'welcome'}
          className={cn({ 'd-none': activeScreenKey !== 'welcome' })}
        >
          <div className='text-center mt-5'>
            <img
              className='logomark'
              src={RembleLogomark}
              alt='Remble'
              width='80'
              fetchpriority='high'
            />
            <h1 className='my-4 title'>Welcome to Remble</h1>
            <p>
              Learn tools to master your mental health, improve your
              relationships, and become your best self with hundreds of
              therapist-created courses, activities, and tips, all in the palm
              of your hand.
            </p>
          </div>
          <div className='onboarding-footer'>
            <p>
              Are you in crisis?
              <br />
              <span className='green'>Do you need help right now?</span>
            </p>
            <p>
              <i className='bi bi-telephone green'></i> Call or text 988
            </p>
            <p>
              <i className='bi bi-send green'></i> Text "HOME" to 741741
            </p>
          </div>
        </Col>
        <Col
          key={'practices'}
          className={cn({ 'd-none': activeScreenKey !== 'practices' })}
        >
          <div className='px-3'>
            <h1>How we help</h1>
            <p>
              We are a mental health and relationship improvement app with tools
              that are practical and fun, created by licensed professionals.
            </p>
          </div>
          <PracticesCarousel />
        </Col>
        <Col
          key={'privacy'}
          className={cn({ 'd-none': activeScreenKey !== 'privacy' })}
        >
          <h1>Privacy and trust</h1>
          <p className='muted'>We work tirelessly to earn your trust!</p>

          <h4 className='green mt-5'>
            <i className='bi bi-archive'></i> Safely stored
          </h4>
          <p>
            Your information is always encrypted when transmitted and stored.
          </p>
          <h4 className='green mt-5'>
            <i className='bi bi-shield-check'></i> Responses encrypted
          </h4>
          <p>
            Your responses on the app are encrypted and not even Remble
            employees can see your work or journal entries.
          </p>
          <h4 className='green mt-5'>
            <i className='bi bi-person-x'></i> No third parties
          </h4>
          <p>
            We will never share your personal information with third parties.
          </p>
        </Col>
        <Col
          key={'personalize'}
          className={cn({ 'd-none': activeScreenKey !== 'personalize' })}
        >
          {!assessmentComplete ? (
            // If the assessment is not complete, show the assessment
            <UserAssessment handleComplete={handleAssessmentComplete} />
          ) : (
            // If the assessment is complete, show the post-assessment review
            <UserAssessmentComplete handleComplete={handleComplete} />
          )}
        </Col>
      </Row>
      {/* Don't show the button on the last screen */}
      {activeScreenIndex < screenKeys.length - 1 && (
        <div className='onboarding-actions'>
          <Button
            size='lg'
            variant='primary'
            className='mt-3 px-5 w-100'
            onClick={_ => handleContinue()}
          >
            Continue
          </Button>
        </div>
      )}
    </div>
  )
}
